<template>
  <van-collapse v-model="activeNames">
    <van-collapse-item class="r-1" title="拍卖详情" name="1">
      <div>详情内容</div>
      <div v-html="data.context"></div>
      <div>标的物介绍详情</div>
      <div v-html="data.subjectIntro"></div>
    </van-collapse-item>
    <van-collapse-item title="竞价成功确认书" name="2">
      <van-cell-group><van-field label="处置单位" :value="data.biddingConfirm.executegov" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="标的物名称" :value="data.biddingConfirm.subjectName" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="标的物网拍链接" :value="data.biddingConfirm.detailUrl" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="网拍公告时间" :value="data.biddingConfirm.noticeTime" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="网拍开始时间" :value="data.biddingConfirm.startTime" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="网拍结束时间" :value="data.biddingConfirm.endTime" placeholder="无" readonly /></van-cell-group>
      <div>标的物介绍详情</div>
      <div v-html="data.biddingConfirm.biddingResult"></div>
    </van-collapse-item>
  </van-collapse>
</template>

<script>
import detailMixin from "../mixins/detail-mixin"
export default {
  name: "judicialSaleCheckDetail",
  mixins: [detailMixin],
  data() {
    return {
      activeNames: ["1", "2", "3", "4"]
    };
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/mixin.scss";
@import "../style.scss";
.r-1 /deep/ .van-collapse-item__content {
  padding: 0px 16px;
}
.coll2 .van-cell__value {
  flex: 1;
  margin-left: 8px;
}
.coll2 .van-cell {
  padding: 10px 0;

  &::after{
    left: 0;
  }
}

.coll3 /deep/ .van-field__label {
  flex: 1;
}
</style>